import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

const HeroBanner = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  const handleStartShopping = () => {
    if (loading) return; // Wait for auth check

    if (user) {
      // User is logged in, take them to products page
      navigate("/products");
    } else {
      // User not logged in, take them to registration
      navigate("/register");
    }
  };

  const handleBecomeSeller = () => {
    if (loading) return;

    if (user) {
      // User is logged in, check if they already have seller access or take them to seller setup
      navigate("/seller");
    } else {
      // User not logged in, take them to registration with seller intent
      navigate("/register?intent=seller");
    }
  };
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden bg-black text-white">
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900 via-black to-gray-900 opacity-90"></div>
      <div className="container mx-auto px-4 relative">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <div className="space-y-4">
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tight">
              Bahamas' Premier
              <span className="block text-white/80">Online Marketplace</span>
            </h1>
            <p className="text-white/70 max-w-2xl mx-auto text-lg md:text-xl leading-relaxed font-light">
              Discover authentic Bahamian products from local artisans and vendors. 
              Experience luxury shopping with island authenticity.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center pt-6">
            <Button
              size="lg"
              className="bg-white text-black hover:bg-gray-200 shadow-lg transition-all text-base font-semibold px-8 py-6 rounded-lg"
              onClick={handleStartShopping}
              disabled={loading}
            >
              {loading ? "Loading..." : user ? "Browse Products" : "Start Shopping"}
            </Button>
            <Button
              size="lg"
              className="bg-black text-white hover:bg-gray-900 border border-white/20 rounded-lg px-8 py-6 text-base font-semibold transition-all shadow-lg"
              onClick={handleBecomeSeller}
              disabled={loading}
            >
              {loading ? "Loading..." : user ? "Seller Dashboard" : "Become a Seller"}
            </Button>
          </div>
          <div className="grid grid-cols-3 gap-12 pt-16 max-w-2xl mx-auto">
            <div className="text-center space-y-2">
              <div className="text-3xl font-extrabold">500+</div>
              <div className="text-sm text-white/60 uppercase tracking-widest">Local Products</div>
            </div>
            <div className="text-center space-y-2">
              <div className="text-3xl font-extrabold">100+</div>
              <div className="text-sm text-white/60 uppercase tracking-widest">Verified Vendors</div>
            </div>
            <div className="text-center space-y-2">
              <div className="text-3xl font-extrabold">24/7</div>
              <div className="text-sm text-white/60 uppercase tracking-widest">Support</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;